import { render, staticRenderFns } from "./AlertBadge.vue?vue&type=template&id=72073296&scoped=true"
import script from "./AlertBadge.vue?vue&type=script&lang=js"
export * from "./AlertBadge.vue?vue&type=script&lang=js"
import style0 from "./AlertBadge.vue?vue&type=style&index=0&id=72073296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72073296",
  null
  
)

export default component.exports